import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import HomePage from './HomePage';
import FamilyTreePage from './FamilyTreePage';
import ChromosomePainterPage from './ChromosomePainterPage';
import IndividualsPage from './IndividualsPage';
import DNASankeyPage from "./components/DNASankeyPage";
import GEDCOMImportPage from './GEDCOMImportPage';
import FamilyFinderPage from './FamilyFinderPage';
import DnaMatchesPage from './DnaMatchesPage';

function App() {
  const [navOpen, setNavOpen] = useState(false);

  // Simple login gate state
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return localStorage.getItem('genealogy-auth') === '1';
  });
  const [loginUser, setLoginUser] = useState('');
  const [loginPass, setLoginPass] = useState('');
  const [loginError, setLoginError] = useState<string | null>(null);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (loginUser === 'sebastianjshaw' && loginPass === 'PatrickCollins') {
      localStorage.setItem('genealogy-auth', '1');
      setIsAuthenticated(true);
      setLoginError(null);
    } else {
      setLoginError('Incorrect username or password.');
    }
  };

  if (!isAuthenticated) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--color-porcelain-light)' }}>
        <form className="genealogy-card" style={{ width: 340, padding: 32, display: 'flex', flexDirection: 'column', gap: 20 }} onSubmit={handleLogin}>
          <h2 className="heading-2" style={{ textAlign: 'center' }}>Genealogy Platform Login</h2>
          <label className="genealogy-label" htmlFor="login-user">Username</label>
          <input
            id="login-user"
            className="add-person-modal-input"
            type="text"
            autoComplete="username"
            value={loginUser}
            onChange={e => setLoginUser(e.target.value)}
            required
          />
          <label className="genealogy-label" htmlFor="login-pass">Password</label>
          <input
            id="login-pass"
            className="add-person-modal-input"
            type="password"
            autoComplete="current-password"
            value={loginPass}
            onChange={e => setLoginPass(e.target.value)}
            required
          />
          {loginError && <div style={{ color: 'var(--color-error)', fontSize: 14, textAlign: 'center' }}>{loginError}</div>}
          <button className="genealogy-btn-primary" type="submit">Login</button>
        </form>
      </div>
    );
  }

  return (
    <Router>
      <nav className="genealogy-card genealogy-navbar">
        <div className="genealogy-navbar-inner">
          <Link to="/" className="genealogy-navbar-logo-link">
            <img src="/logo.png" alt="Genealogy Platform Logo" className="genealogy-navbar-logo" />
          </Link>
          <button
            className="genealogy-navbar-toggle"
            aria-label="Toggle navigation"
            onClick={() => setNavOpen(open => !open)}
          >
            <span className="genealogy-navbar-hamburger">&#9776;</span>
          </button>
          <ul className={`genealogy-navbar-links${navOpen ? ' open' : ''}`}>
            <li><Link className="genealogy-btn-secondary" to="/">Home</Link></li>
            <li><Link className="genealogy-btn-secondary" to="/tree">Family Tree</Link></li>
            <li><Link className="genealogy-btn-secondary" to="/chromosome-painter">Chromosome Painter</Link></li>
            <li><Link className="genealogy-btn-secondary" to="/individuals">Individuals</Link></li>
            <li><Link className="genealogy-btn-secondary" to="/dna-flow">DNA Flow</Link></li>
            <li><Link className="genealogy-btn-secondary" to="/matches">DNA Matches</Link></li>
            <li><Link className="genealogy-btn-secondary" to="/family-finder">Family Finder</Link></li>
            <li><Link className="genealogy-btn-secondary" to="/import">Import GEDCOM</Link></li>
          </ul>
        </div>
      </nav>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tree" element={<FamilyTreePage />} />
        <Route path="/chromosome-painter" element={<ChromosomePainterPage />} />
        <Route path="/individuals" element={<IndividualsPage />} />
        <Route path="/dna-flow" element={<DNASankeyPage />} />
        <Route path="/matches" element={<DnaMatchesPage />} />
        <Route path="/family-finder" element={<FamilyFinderPage />} />
        <Route path="/import" element={<GEDCOMImportPage />} />
      </Routes>
    </Router>
  );
}

export default App;
